import React, { useEffect } from 'react';
import { useLocalStorage } from 'react-use';

import { RemoteControlContext } from '../ContextProvider';
import Router from './Router';
import NavbarHeader from './NavbarHeader';

import BottomMenu from './BottomMenu';
import { useMutation, useQuery } from '@apollo/client';
import { CREATE_LIVE_EVENT_SUBSCRIPTION, DELETE_LIVE_EVENT_SUBSCRIPTION, GET_EVENTS } from '../api/queries/live_event';
import { sortFnByScheduleAndCreationTime } from '../helpers/nowPlaying';
import ErrorToast from './ErrorToast';

export default function RouterWrapper ({ remote_control }) {
    const [currentOrg, setCurrentOrg] = useLocalStorage('current_org', remote_control.organizations[0]);

    const org_id = currentOrg.id;

    const { data, error, loading, refetch } = useQuery(GET_EVENTS, {
        fetchPolicy: 'cache-and-network',
        variables: {
            org_id
        }
    });

    useEffect(() => {
        if (error && error.message === 'Not allowed' && remote_control.organizations.length) {
            return setCurrentOrg(remote_control.organizations[0]);
        }
    }, [error, remote_control, setCurrentOrg]);

    const [deleteLiveEventSubscription, { loading: liveEventDeleteLoading }] = useMutation(DELETE_LIVE_EVENT_SUBSCRIPTION, {
        variables: { organization_id: org_id }, refetchQueries: refetch
    });

    const [createLiveEventSubscription, { loading: liveEventCreateLoading }] = useMutation(CREATE_LIVE_EVENT_SUBSCRIPTION, {
        variables: { org_id }, refetchQueries: refetch
    });

    const liveEvents = data ? data.Organization.liveEvents : [];

    const nowPlaying = liveEvents.filter(event => event.subscribed && event.status === 'LIVE')
        .sort(sortFnByScheduleAndCreationTime)
        .slice(0, 1);

    const isLoading = loading || liveEventDeleteLoading || liveEventCreateLoading;

    const handleEventSubClick = async (event, force) => {
        if (event.subscribed) return deleteLiveEventSubscription({ variables: { live_event_id: event.id } });

        if (force && nowPlaying.length) await deleteLiveEventSubscription({ variables: { live_event_id: nowPlaying[0].id } });

        return createLiveEventSubscription({ variables: { eventId: event.id } });
    };

    return (
        <RemoteControlContext.Provider value={{
            remote_control,
            organizations: remote_control.organizations,
            currentOrg,
            setCurrentOrg,
            isLoading,
            liveEvents,
            nowPlaying,
            handleEventSubClick
        }}>
            <NavbarHeader />
            <main>
                {error ? <ErrorToast message={error.message} severity='error' /> : <Router />}
            </main>
            <BottomMenu />
        </RemoteControlContext.Provider>
    );
}
